import axios from './http'

export function importBlockedInfo(token, params){
  return axios({
    method: 'post',
    url: '/api/blocked/importBlockedInfo',
    responseType: 'blob',
    headers: {
      'authorization': token
    },
    data: params
  })
}

export function putBlockedInfoExcel(token,supplierId, params){
  return axios({
    method: 'post',
    url: '/api/blocked/put-blockedInfo-excel',
    headers: {
      'authorization': token,
      'supplierId' : supplierId,
      'Content-Type':'multipart/form-data'
    },
    data: params
  })
}

export function importBlockedInfoAllNetWork(token){
  return axios({
    method: 'post',
    url: '/api/blocked/importBlockedInfoAllNetWork',
    responseType: 'blob',
    headers: {
      'authorization': token
    },
  })
}
